import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectListItems } from '../../../../../../redux/library/selector';
import { logisticsOrders } from '../../../../../../redux/logistics-orders/action';
import { jobs } from '../../../../../../redux/jobs/action';
import { customers } from '../../../../../../redux/customers/action';
import PageLoader from '../../../../../../components/PageLoader';
import { selectLogisticsOrdersQueryItems } from '../../../../../../redux/logistics-orders/selector';
import { selectJobsListItems } from '../../../../../../redux/jobs/selector';
import { selectCustomersListItems } from '../../../../../../redux/customers/selector';
import OrderComponent from '../../logistics-orders/components/order.component';
import { journeys } from '../../../../../../redux/journey/action';
import { selectJourneyQueryItems } from '../../../../../../redux/journey/selector';
import JourneyBasicComponent from '../components/journey-Basic.info';
import JourneyComponent from '../components/Jornet_component';
import { journeyLeg } from '../../../../../../redux/journeyLeg/action';

const ManagementLogisticsJourney = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const journeyQuery = useSelector(selectJourneyQueryItems)
  const jobItemsData = useSelector(selectJobsListItems)
  const customerItemsData = useSelector(selectCustomersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const libraryData = useSelector(selectListItems)
  const [
    selectedOrder,
    setSelectedOrder
  ] = useState<any>({})


  const fetchOrderById = async () => {
    await dispatch(journeys.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/order-layer/journies/fetch-detail`, entity: 'logisticsOrders', jsonData: {
        Context: {},
        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
      
    }))
     await dispatch(journeyLeg.list({
           url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/shipment-legs/fetch`,
           entity: 'journeyLeg',
           jsonData: {
             context: {},
             Records: [
               {
     
                 JourneyId: parmas?.id
               }
            ]}
            })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedOrder({ ...selectedOrder, [field]: event });
  }


  useEffect(
    () => {


          if (parmas?.id > 0) {
            fetchOrderById()
          } 
    },
    []
  )
  useEffect(
    () => {
      if (isQuery) {
        setSelectedOrder(journeyQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {

  }

  const back = () => {
    navigate('/management/logistics/transport/journey')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <JourneyComponent
          orderStatus={libraryData?.result?.LogisticsOrderStatus}
          ShippingStatusId={libraryData?.result?.ShippingStatus}
          customers={customerItemsData?.result?.items}
          selectedOrder={selectedOrder}
          onInnerBasicFormChange={handleInnerFormChange}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementLogisticsJourney;